/* Eagle Leather: product-page behaviour for Pillar (loaded from snippets/el-product-assets.liquid).
   1. Size chart dialog   - [data-el-size-chart-open] opens the native <dialog> named in aria-controls (showModal gives
                            focus trap + Esc + focus return); close button and backdrop click close it. Delegated, so it
                            keeps working after Pillar re-renders <variant-selects> on every option change.
   2. Key specs link      - "See all specifications" opens the specs accordion before scrolling to it.
   3. Shipping promise    - ONE delivery line ([data-el-ship-line]): "Order within 2h 14m to ship today" before the cutoff,
                            else "Ships tomorrow/Monday"; in-stock / out-of-stock swap on variant change.
   4. ZIP estimator       - ported from live Xtra snippets/el-ship-estimator.liquid (same air options). EL 2026-10-02:
                            the 3-digit ZIP-prefix ground transit table moved to assets/el-shipping.js (window.elZipGroundDays).
                            EL 2026-10-01: dates from window.elShipMath (handling days,
                            Mon-Fri carrier transit, air never slower than Ground, one Fastest/one Slowest by actual date);
                            +14 days only for continue-selling (backorder) variants; deny-policy sold-out variants get a
                            call-for-availability message.
   All dates use window.elShipping (snippets/el-shipping-config.liquid): cutoff, time zone, ship weekdays,
   handling days, closed dates. Computed in the browser so cached HTML never shows a stale day.
   EL 2026-10-02 (pack vs carrier days): line 1 uses elShipMath().eta() (packed today / store closed / next carrier day);
   the pickup line ([data-el-pickup-line]) gets its readiness from elShipMath().pickupStatus().
   EL 2026-10-02: phone, city and the backorder delay come from window.elStore (Store info metaobject, published by
   snippets/el-shipping-config.liquid); the literals below are only the fallback if that script is missing. */
(function () {
  'use strict';
  if (window.elProductInit) return;
  window.elProductInit = true;

  var EL = window.elShipping || { tz: 'America/Los_Angeles', tzLabel: 'PT', cutoffHour: 12, cutoffMinute: 30, shipDays: [1, 2, 3, 4, 5], handlingDays: 1, closedDates: [] };
  var STORE = window.elStore || {};
  var PHONE = STORE.phone || '253-581-3220';
  var CITY = STORE.city || 'Lakewood';
  // "(253) 581-3220" for a 10-digit US number (the sold-out wording), otherwise the number as entered.
  function phoneParens(p) { var d = String(p).replace(/\D/g, ''); if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1); return d.length === 10 ? '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6) : p; }

  /* ---------- 1. Size chart ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-el-size-chart-open]');
    if (open) {
      var dialog = document.getElementById(open.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function') {
        e.preventDefault();
        dialog.showModal();
      }
      return;
    }
    var close = e.target.closest('[data-el-size-chart-close]');
    if (close) {
      var d = close.closest('dialog');
      if (d) d.close();
      return;
    }
    if (e.target.matches && e.target.matches('dialog.el-size-chart')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });

  /* ---------- 2. Key specs -> full specs ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-el-open-specs]');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    if (target.tagName === 'DETAILS' && !target.hasAttribute('open')) {
      try { target.open = true; } catch (err) { target.setAttribute('open', ''); }
    }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var summary = target.querySelector('summary');
    if (summary) summary.focus({ preventScroll: true });
  });

  /* ---------- shared date math: window.elShipMath from assets/el-shipping.js (one rule set for ETA, countdown, ZIP) ---------- */
  var MATH = typeof window.elShipMath === 'function' ? window.elShipMath(EL) : null;

  /* ---------- 3. Shipping promise ---------- */
  function variantState(root, variant) {
    var states = {};
    try { states = JSON.parse(root.dataset.elStates || '{}'); } catch (err) { states = {}; }
    var st = variant && states[String(variant.id)];
    if (st) return st;
    return variant && variant.available === false ? 'soldout' : 'in';
  }

  function setAvailability(root, variant) {
    var available = !!variant.available;
    root.dataset.available = available ? 'true' : 'false';
    root.dataset.elState = variantState(root, variant);
    // EL 2026-10-06: free-shipping line follows the selected size's price.
    var free = root.querySelector('[data-el-free]');
    var freeText = free && free.querySelector('[data-el-free-text]');
    var cents = typeof variant.price === 'number' ? variant.price : parseInt(variant.price, 10);
    if (freeText && !isNaN(cents)) {
      freeText.textContent = cents >= parseInt(free.getAttribute('data-min'), 10) ? free.getAttribute('data-yes') : free.getAttribute('data-no');
    }
    root.querySelectorAll('.el-ship__line--in').forEach(function (n) { n.hidden = !available; });
    var oosLine = root.querySelector('.el-ship__line--oos');
    if (oosLine) oosLine.hidden = available;
    updateLine(root);
    // A previous ZIP result was for the old variant: clear it so the shopper never reads a stale estimate.
    var results = root.querySelector('[data-el-zip-results]');
    if (results && results.childNodes.length) results.textContent = '';
  }

  // Line 1: "Order within 2h 14m to ship today" before the cutoff on a ship day, otherwise "Ships tomorrow/Monday".
  // One line only; the pickup alternative is its own line ("Or pick up in store in <city>").
  function updateLine(root) {
    var line = root.querySelector('[data-el-ship-line]');
    if (!line || !MATH) return;
    var left = MATH.minutesToCutoff();
    if (left > 0) {
      var h = Math.floor(left / 60), m = left % 60;
      var txt = h > 0 ? h + 'h ' + m + 'm' : (m > 1 ? m + ' min' : 'less than a minute');
      line.textContent = 'Order within ' + txt + ' to ship today';
    } else {
      line.textContent = MATH.eta();
    }
    // EL 2026-10-02: pickup line readiness from store hours / store-closed dates:
    // "Or pick up in store in Lakewood, ready within 2 hours" | "…, ready when we open tomorrow at 10 AM"
    var pick = root.querySelector('[data-el-pickup-line]');
    if (pick && typeof MATH.pickupStatus === 'function') {
      var base = pick.getAttribute('data-base') || pick.textContent;
      pick.textContent = base + ', ' + MATH.pickupStatus(undefined, EL.pickupReady || 'within 2 hours');
    }
  }

  function initShip() {
    var roots = document.querySelectorAll('[data-el-ship]');
    if (!roots.length) return;
    roots.forEach(function (r) { updateLine(r); });
    setInterval(function () { roots.forEach(function (r) { updateLine(r); }); }, 30000);

    // Pillar publishes the newly selected variant after it re-renders the product info.
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (payload) {
        var v = payload && payload.data && payload.data.variant;
        if (!v) return;
        var section = payload.data.sectionId;
        roots.forEach(function (r) {
          var owner = r.closest('product-info');
          if (section && owner && owner.dataset.section && owner.dataset.section !== section) return;
          setAvailability(r, v);
        });
      });
    }
  }

  /* ---------- 4. ZIP delivery estimator ---------- */
  // ZIP -> ground transit days: window.elZipGroundDays from assets/el-shipping.js (same table the cart estimator uses).
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function groundDaysFor(zip) { return typeof window.elZipGroundDays === 'function' ? window.elZipGroundDays(zip) : 0; }

  function initZip() {
    document.querySelectorAll('[data-el-zip]').forEach(function (box) {
      var form = box.querySelector('[data-el-zip-form]');
      var input = box.querySelector('[data-el-zip-input]');
      var errorEl = box.querySelector('[data-el-zip-error]');
      var results = box.querySelector('[data-el-zip-results]');
      var backorderDays = parseInt(box.dataset.backorderDays, 10);
      if (isNaN(backorderDays)) backorderDays = typeof STORE.backorderDays === 'number' ? STORE.backorderDays : 14;
      if (!form || !input || !MATH) return;

      function fail(msg) {
        errorEl.textContent = msg;
        input.setAttribute('aria-invalid', 'true');
        results.textContent = '';
        input.focus();
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        errorEl.textContent = '';
        input.removeAttribute('aria-invalid');
        results.textContent = '';
        var zip = input.value.trim();
        if (!/^\d{5}$/.test(zip)) { fail('Please enter a valid 5-digit ZIP code.'); return; }
        var ground = groundDaysFor(zip);
        if (!ground) { fail('Shipping data is unavailable for ZIP prefix ' + zip.substring(0, 3) + '. Please call ' + PHONE + ' for a quote.'); return; }

        var ship = box.closest('[data-el-ship]');
        var state = ship ? (ship.dataset.elState || (ship.dataset.available === 'false' ? 'soldout' : 'in')) : 'in';
        if (state === 'soldout') {
          results.appendChild(el('p', 'el-zip__soldout font-body-bolder', 'This size is sold out. Call ' + phoneParens(PHONE) + ' for availability.'));
          return;
        }
        var backorder = state === 'backorder';
        var est = MATH.estimate(ground, { backorderDays: backorder ? backorderDays : 0 });

        var list = el('ul', 'el-zip__list list-unstyled');
        est.services.forEach(function (x) {
          var li = el('li', 'el-zip__method');
          li.appendChild(el('span', 'el-zip__name font-body-bolder', x.name));
          if (x.tag) li.appendChild(el('span', 'el-zip__tag el-zip__tag--' + x.tag.toLowerCase(), x.tag));
          var when = el('span', 'el-zip__date');
          when.appendChild(document.createTextNode('Get it by '));
          when.appendChild(el('strong', '', fmt(x.date)));
          li.appendChild(when);
          li.appendChild(el('span', 'el-zip__detail text-sm text-subtext', x.days + ' business day' + (x.days !== 1 ? 's' : '') + ' in transit'));
          list.appendChild(li);
        });
        results.appendChild(list);
        var fine = 'Ships from our ' + CITY + ' store ' + fmt(est.ship) + (backorder ? ' (includes a ' + backorderDays + '-day backorder delay)' : '') +
          '. Carrier transit counts business days (Mon–Fri).';
        results.appendChild(el('p', 'el-zip__fine text-sm text-subtext', fine));
      });
    });
  }

  /* ---------- 5. Long description ---------- */
  // EL 2026-10-09: the SEO descriptions run 1,000+ words. Fully open, they push key specs, tabs and reviews thousands of
  // pixels down (7,000px on a phone). The whole text stays in the HTML for search engines; only the visible height is
  // capped until the shopper opens it. Short descriptions (under 1.5x the cap) are left alone.
  var DESC_CAP = 480;
  function initDesc() {
    document.querySelectorAll('product-info .product__block--description').forEach(function (d, i) {
      if (d.hasAttribute('data-el-desc')) return;
      if (!d.offsetHeight || d.scrollHeight <= DESC_CAP * 1.5) return;
      if (location.hash && location.hash.length > 1) {
        try { if (d.querySelector(location.hash)) return; } catch (err) {}
      }
      d.setAttribute('data-el-desc', '');
      if (!d.id) d.id = 'el-desc-' + i;
      d.classList.add('el-desc', 'el-desc--clamped');
      var btn = el('button', 'el-desc__toggle btn--link', 'Read full description');
      btn.type = 'button';
      btn.setAttribute('aria-controls', d.id);
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = d.classList.toggle('el-desc--clamped') === false;
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Show less' : 'Read full description';
        if (!open && d.getBoundingClientRect().top < 0) d.scrollIntoView({ block: 'start' });
      });
      d.insertAdjacentElement('afterend', btn);
    });
  }

  function init() { initShip(); initZip(); initDesc(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
